import "./App.css";
import MatchesList from "./components/Matches/Matches";
import NewMatch from "./components/NewMatch/NewMatch";
import Nav from "./components/Nav/Nav";
import EditMatch from "./components/EditMatch/EditMatch";
import Entry from "./components/Entry/Entry";
import MatchSummary from "./components/MatchSummary/MatchSummary";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { useEffect } from "react";
function App() {
  // useEffect(() => {
  //   window.parent.postMessage(
  //     JSON.stringify({
  //       Authorization: "test_token",
  //     }),
  //     "*"
  //   );
  // }, []);

  return (
    <Router>
      <div className="App">
        <div>
          <Nav />
          <Switch>
            <Route path="/admin/match/:code" children={<EditMatch />} />
            <Route path="/admin/new" component={(props) => <NewMatch />} />
            <Route path="/match/:code" children={<EditMatch />} />
            <Route path="/admin" component={(props) => <MatchesList />} />
            <Route
              path="/match-summary"
              component={(props) => <MatchSummary />}
            />

            <Route path="/entry" component={(props) => <Entry />} />
            <Route path="/" component={(props) => <MatchesList />} />
          </Switch>
        </div>
      </div>
    </Router>
  );
}

export default App;
